<div [formGroup]="form" *ngIf="form" (keydown.tab)="$event.stopPropagation()" class="client-form"
    [class.client-form--compact]="compact" [class.client-form--expanded]="showMore">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__name">

        <label class="label-input" for="input-name">Nome/Razão Social <span class="required">*</span></label>

        <mat-form-field appearance="outline" fxFlex>
            <mat-label>Nome</mat-label>
            <input type="text" #nomeInput placeholder="Nome/Razão Social" matInput formControlName="name" required>
            <mat-error *ngIf="form.get('name')?.hasError('required')">Informe o nome</mat-error>
        </mat-form-field>

    </div>

    <!-- ORCA-1945: CPF/CNPJ sempre à vista (com CNPJ o formulário é preenchido sozinho) -->
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__doc">
        <label class="label-input" for="cpf_cnpj">CPF/CNPJ</label>

        <mat-form-field appearance="outline" fxFlex>
            <mat-label>CPF/CNPJ</mat-label>
            <input type="text" id="cpf_cnpj" inputmode="numeric" matInput formControlName="cpf_cnpj" mask="000.000.000-00||00.000.000/0000-00">
            <mat-hint *ngIf="!form.get('cpf_cnpj')?.value">Com o CNPJ, preenchemos nome, contato e endereço da empresa.</mat-hint>
            <mat-error *ngIf="form.get('cpf_cnpj')?.invalid">CPF ou CNPJ inválido</mat-error>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__more">
        <label class="label-input" for="state_registration">Inscrições</label>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex>
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Inscrição Estadual</mat-label>
                <input type="text" inputmode="numeric" id="state_registration" matInput
                    formControlName="state_registration" mask="0*" maxlength="30">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Inscrição Municipal</mat-label>
                <input type="text" inputmode="numeric" matInput
                    formControlName="municipal_registration" mask="0*" maxlength="30">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__more">
        <label class="label-input" for="input-phone">Contato</label>
        

        <mat-form-field appearance="outline" fxFlex>
            <mat-icon matSuffix class="secondary-text">
                account_box
            </mat-icon>
            <mat-label>Nome do Responsável</mat-label>
            <input type="text" matInput formControlName="responsible">
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__contact">

        <label class="label-input" for="input-phone">
            <!-- Contato -->
        </label>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex>
            <mat-form-field appearance="outline" fxFlex class="client-form__more">
                <mat-label>E-mail</mat-label>
                <input type="email" inputmode="email" autocapitalize="off" placeholder="E-mail" matInput formControlName="email">
                <mat-error *ngIf="form.get('email')?.hasError('email')">E-mail inválido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>{{ compact ? 'Telefone/WhatsApp' : 'Telefone' }}</mat-label>
                <input type="tel" placeholder="Telefone" matInput formControlName="phone" autocomplete="off"
                    name="phone" mask="(00) 00009-0000">
                <mat-error *ngIf="form.get('phone')?.invalid">Telefone incompleto</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="client-form__toggle" *ngIf="compact">
        <button type="button" class="oa-btn oa-btn--ghost" (click)="showMore = !showMore"
            [attr.aria-expanded]="showMore">
            <mat-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</mat-icon>
            {{ showMore ? 'Menos dados' : 'Mais dados (e-mail, endereço, inscrições)' }}
        </button>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__more">

        <label class="label-input" for="input-phone">Endereço</label>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex>
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>CEP</mat-label>
                <input type="text" inputmode="numeric" placeholder="CEP" matInput formControlName="cep" mask="00000-000"
                    (blur)="changeAddressByCep()">
                <mat-error *ngIf="form.get('cep')?.invalid">CEP incompleto</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Logradouro</mat-label>
                <input type="text" placeholder="Logradouro" matInput formControlName="address">
            </mat-form-field>
        </div>

    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__more">
        <label class="label-input" for="input-phone"></label>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex>
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Número</mat-label>
                <input type="text" placeholder="Número" matInput formControlName="address_number">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Complemento</mat-label>
                <input type="text" placeholder="Complemento" matInput formControlName="address_complement">
            </mat-form-field>
        </div>

    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="stretch"
        class="form-group client-form__more">
        <label class="label-input" for="input-phone"></label>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" fxFlex>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Bairro</mat-label>
                <input type="text" placeholder="Bairro" matInput formControlName="address_neighborhood">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Cidade</mat-label>
                <input type="text" placeholder="Cidade" matInput formControlName="address_city">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Estado</mat-label>
                <input type="text" placeholder="Estado" matInput formControlName="address_state">
            </mat-form-field>
        </div>

    </div>

    <div *ngIf="client" class="form-actions" fxLayout="row" fxLayoutAlign="end">
        <button type="button" class="oa-btn oa-btn--primary" [disabled]="loading || !form.dirty || !form.valid"
            [attr.aria-busy]="loading || null" (click)="update()">
            <span>Salvar alterações</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
    </div>
</div>
